module.exports = __webpack_public_path__ + "static/img/Frame23.dda2dce1.png";